import React, {useEffect, useState, useCallback, useContext} from "react";
import { MdOutlineRemoveRedEye, MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import SideBar from "../../../components/SideBar/SideBar";
import TopNav from "../../../components/TopNav/TopNav";
import TableColumn from "../../../components/TableColumn/TableColumn";
import api from "../../../services/api";
import "../../Users/Users.scss";
import Button from "../../../components/Buttons/Button";
import {FormDataContext} from "../../../FormDataContext";
import {toast} from "react-toastify";

const Participants = () => {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        Number(localStorage.getItem("ListCurrentPageParticipants")) || 1
    );

    const records = 10;
    const [userToDelete] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const { formData } = useContext(FormDataContext);
    const [chatData, setChatData] = useState({});
    const [sortBy, setSortBy] = useState(null);
    const [formDataToSend, setFormDataToSend] = useState(null);

    const [sortDirection, setSortDirection] = useState("null");
    const getUsers = useCallback(
        async (page) => {
            try {
                const response = await api.get(`/users`, {
                    params: {
                        page: page,
                        records: records,
                        sort_column: sortBy,
                        sort: sortDirection,
                        search: searchTerm, // Add search term
                    },
                });

                const itemsTableColumns = response.data.data.map((user) => ({
                    Name: `${user.firstName} ${user.lastName}`,
                    Birthday: user.birthday,
                    Gender: user.gender,
                    Email: user.email,
                    Phone: user.phone,
                    id: user.id,
                }));

                setUsers([...itemsTableColumns]);
                setTotalPages(response.data.total);
            } catch (error) {
                console.log(`users get request didn't work. error: ${error}`);
            }
        },
        [sortBy, sortDirection, searchTerm] // Add searchTerm as a dependency
    );

    useEffect(() => {
        getUsers(currentPage);
    }, [currentPage, sortDirection, searchTerm, getUsers]);

    useEffect(() => {
        if (formData) {
            console.log('Form data received:', formData);

            const { name, expiryDate, imageFiles } = formData;
            console.log('Chat Name:', name, 'Expiry Date:', expiryDate);

            // Rebuild the FormData with image files and set chat data
            setChatData({ name, expiryDate });

            if (imageFiles && imageFiles.length > 0) {
                // Filter out any invalid files (non-File objects or undefined)
                const validImageFiles = imageFiles.filter(file => file instanceof File);
                console.log('Valid Image Files:', validImageFiles);

                // If there are valid image files, rebuild the FormData
                if (validImageFiles.length > 0) {
                    const formDataObj = new FormData();
                    formDataObj.append('name', name);
                    formDataObj.append('chatExpiryDate', expiryDate);

                    validImageFiles.forEach((file, index) => {
                        console.log(`Appending image ${index + 1}:`, file);  // Log each file
                        formDataObj.append('image', file);
                    });

                    // Log the FormData using getAll to see the files
                    console.log('FormData prepared (images):', formDataObj.getAll('image'));

                    // Optionally set this FormData to send to the backend
                    setFormDataToSend(formDataObj);
                } else {
                    console.warn('No valid image files to append.');
                }
            } else {
                console.log('No image files to append.');
            }
        }
    }, [formData]);




    const [selectedItems, setSelectedItems] = useState([]);

    const handleSelectionChange = (selectedIds) => {
        setSelectedItems(selectedIds);
        console.log('Selected Items:', selectedIds);
    };
    const handleSubmit = (e) => {
        e.preventDefault();

        // Check if formDataToSend has been set in the useEffect
        if (!formDataToSend) {
            console.error('Form data is not ready for submission');
            toast.error('Form data is missing or incomplete.');
            return;
        }

        // Log the FormData to confirm it's ready for submission
        console.log('Submitting FormData:', formDataToSend);

        // Add selected items to the FormData
        const uniqueItems = [...new Set(selectedItems)];  // This removes any duplicates

        // Add unique selected items to the FormData
        uniqueItems.forEach(item => {
            formDataToSend.append('participants', item);
        });


        // Log the final FormData (including selectedItems)
        console.log('FormData after adding selected items:', formDataToSend);

        // Send the form data to the backend using the prepared FormData
        api.post('/chat/admit/create-chat', formDataToSend)
            .then(response => {
                // Handle the response from the backend (e.g., show a success message or navigate)
                console.log('Response from backend:', response);
                toast.success('Data submitted successfully.');

                // Navigate to /chats after successful submission
                navigate('/chats');
            })
            .catch(error => {
                // Handle any errors during submission
                console.error('Error submitting form:', error);
                toast.error('An error occurred while submitting the form. Please try again.');
            });
    };



    const handleDelete = (id) => {
        const deleteUser = async () => {
            try {
                await api.delete(`/users/${id}`);
                setDeleteModal(false);
                getUsers(currentPage, sortDirection);
            } catch (err) {
                console.log(`failed to delete user. this is the error: ${err}`);
            }
        };

        deleteUser();
    };

    const fetchAllData = async () => {
        try {
            const response = await api.get(`/users`, {
                params: {
                    records: 9999999999,
                },
            });

            return response.data.data.map((user) => ({
                Name: `${user.firstName} ${user.lastName}`,
                Birthday: user.birthday,
                Gender: user.gender,
                Email: user.email,
                Phone: user.phone,
                id: user.id,
            }));
        } catch (error) {
            console.log(`Error fetching all data: ${error}`);
            return [];
        }
    };

    const columns = [
        "Name",
        "Birthday",
        "Gender",
        "Email",
        "Phone",
    ];

    const sortableColumns = ["Name", "Birthday", "Gender"];
    const handleChange = (event) => {
        const value = event.target.value;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
        localStorage.setItem("ListCurrentPageParticipants", page);
    };

    useEffect(() => {
        const storedPage = localStorage.getItem("ListCurrentPageParticipants");
        setCurrentPage(Number(storedPage) || 1);
    }, []);

    const sortColumnsMapping = {
        Name: "firstName",
        Birthday: "birthday",
        Gender: "gender",
    };

    const handleSort = (columnName) => {
        const backendColumnName = sortColumnsMapping[columnName];
        if (sortBy === backendColumnName) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortBy(backendColumnName);
            setSortDirection("asc");
        }
    };

    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                {deleteModal && (
                    <DeleteModal
                        handleDelete={handleDelete}
                        setDeleteModal={setDeleteModal}
                        modToDelete={userToDelete}
                        tableName={"USERS"}
                    />
                )}
                <article className="page-content">
                    <section className="users">
                        <TableColumn
                            title="Select participants"
                            backUrl="/create-chat"
                            hasHeader={true}
                            columns={columns}
                            data={users}
                            sortableColumns={sortableColumns}
                            hasExport={true}
                            hasSearch={true}
                            totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={handlePageChange}
                            records={records}
                            inputSearchProps={{value: searchTerm, onChange: handleChange}}
                            fetchAllData={fetchAllData}
                            onSort={handleSort}
                            enableSelection={true}
                            onSelectionChange={handleSelectionChange}
                        />

                        <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Button
                                label="Submit"
                                type="button"
                                primaryBtn
                                onClick={handleSubmit}
                            />
                        </div>


                    </section>

                </article>
            </div>
        </main>
    );
};

export default Participants;
